import { render, staticRenderFns } from "./CorrespondentAdministrative.vue?vue&type=template&id=30c5e43d"
import script from "./CorrespondentAdministrative.vue?vue&type=script&lang=js"
export * from "./CorrespondentAdministrative.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports